
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offer-trial",
      function () {
        return require("private-next-pages/offer-trial.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offer-trial"])
      });
    }
  